<template>
  <div :class="{ 'uploading-data': isUploadingData }" class="container-images">
    <div class="main-image">
      <img v-if="activeImage.length > 0" :src="activeImage" @click="showLightbox" />
      <div
        v-if="activeImage.length > 0"
        v-hidden="containerType + '-waste-area:edit'"
        class="delete-photo"
        @click="onDeletePhoto"
      />
      <div v-if="activeImage.length > 0" class="show-photo-gallery" @click="showLightbox" />
      <div v-if="activeImage.length === 0" class="no-image" />
    </div>

    <div class="all-images">
      <template v-for="(image, index) in photos">
        <div :key="index" class="all-images__child">
          <div :class="{ 'image-checked': image.active }" class="all-images__child--img">
            <img v-if="image.url" :src="image.url" @click="onClickImage(image)" />
            <div v-if="!image.url" v-hidden="containerType + '-waste-area:edit'" class="add-image" @click="onAddImage(image)" />
          </div>
          <div :title="image.own_id" class="all-images__child--name">{{ transformSideCapture(image.side) }}</div>
        </div>
      </template>
    </div>

    <div class="upload-image">
      <input
        ref="inputUploadFile"
        type="file"
        name="pic"
        accept=".jpg, .jpeg, .png, image/jpeg, image/png"
        @change="onChangeUpload($event)"
      />
    </div>

    <lightbox id="mylightbox" ref="lightbox" :images="galleryPhotos" />
  </div>
</template>

<script>
import Lightbox from "vue-my-photos/src/lightbox.vue";
import { mapActions } from "vuex";

export default {
  name: "ContainerImage",
  components: { Lightbox },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    fieldname: {
      type: String,
      default: ""
    },
    containerType: {
      type: String,
      default: ""
    },
    update: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      images: [
        {
          side: "FRONT",
          image: ""
        },
        {
          side: "BACK",
          image: ""
        },
        {
          side: "RIGHT",
          image: ""
        },
        {
          side: "LEFT",
          image: ""
        }
      ],
      lastClickedSide: "",
      activeImage: "",
      isUploadingData: false
    };
  },
  computed: {
    photos: {
      get() {
        let newValue = this.images.concat(this.value);
        newValue = newValue.reduce((acc, curr) => {
          const findElem = acc.findIndex(el => el.side === curr.side);
          curr.own_id = curr.own_id || Math.random();
          if (findElem > -1 && curr.side !== "OTHER") {
            acc.splice(findElem, 1, curr);
          } else {
            acc.push(curr);
          }
          return acc;
        }, []);
        newValue.push({
          side: "OTHER",
          image: "",
          own_id: 0
        });
        return newValue;
      },
      set(newValue) {
        const imageElements = newValue.filter(s => s.url && s.url.length > 0);

        this.$emit("update", {
          value: imageElements,
          fieldname: this.fieldname
        });
      }
    },
    galleryPhotos: {
      get() {
        return this.photos
          .filter(photo => typeof photo.url !== "undefined")
          .map((photo, index) => ({
            name: photo.url,
            alt: this.transformSideCapture(photo.side),
            id: index
          }));
      }
    }
  },
  watch: {
    photos() {
      this.getActiveImage();
    }
  },
  methods: {
    ...mapActions(["uploadImage"]),
    getActiveImage() {
      this.photos
        .filter(photo => typeof photo.url !== "undefined")
        .map(s => {
          if (this.activeImage === "") {
            s.active = true;
            this.activeImage = s.url;
            this.lastClickedSide = s;
          }
        });
    },
    onDeletePhoto() {
      this.photos = this.photos.filter(s => s.image !== this.lastClickedSide.image);
    },
    onClickImage(image) {
      this.activeImage = image.url;
      this.lastClickedSide = image;
      this.photos = this.photos.map(s => {
        if (s.own_id === image.own_id) {
          s.active = true;
        } else {
          s.active = false;
        }
        return s;
      });
    },
    onAddImage(side) {
      this.lastClickedSide = side;
      this.$refs.inputUploadFile.click();
    },
    onChangeUpload(e) {
      const file = e.target.files[0];
      const formData = new FormData();

      if (!file) {
        return;
      }

      formData.append("files", file);
      this.isUploadingData = true;

      this.uploadImage(formData).then(response => {
        const uploadData = response.data[0];

        this.isUploadingData = false;
        this.photos = this.photos.map(image => {
          if (image.own_id === this.lastClickedSide.own_id) {
            this.activeImage = uploadData.url;
            image.url = uploadData.url;
            image.image = uploadData.id;
            image.active = true;
          } else {
            image.active = false;
          }
          return image;
        });
      });
      e.target.value = "";
    },
    transformSideCapture(sideName) {
      switch (sideName) {
        case "FRONT":
          return "Фронт";
        case "BACK":
          return "Тыл";
        case "RIGHT":
          return "Справа";
        case "LEFT":
          return "Слева";
        case "OTHER":
          return "Другое";
        default:
          return "Другое";
      }
    },
    showLightbox() {
      const imageName = this.activeImage;

      this.$refs.lightbox.show(imageName);
    }
  }
};
</script>
